import React, { useMemo } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { DropDownProps, Menu } from 'antd';
import { Icon, Dropdown } from 'Components';
import { MenuClickEventHandler } from 'rc-menu/lib/interface';
import styles from './Dropdown.module.scss';

interface Option {
	key: string;
	label: string;
	danger?: boolean;
}

type Value = string | undefined;

export type DropdownMenuProps = Pick<DropDownProps, 'className'> & {
	onChange?(value: Value): void;
	value?: Value;
	options: Option[];
	arrow: boolean;
	disabled?: boolean;
	coverTrigger?: boolean;
};

const DropdownMenu: React.FC<DropdownMenuProps> = ({
	arrow,
	onChange,
	options,
	className,
	value,
	disabled = false,
	coverTrigger = false,
	children
}) => {
	const { t } = useTranslation();

	const handleClick: MenuClickEventHandler = (e) => {
		const newValue = (e.key as unknown) as string;
		onChange?.(newValue);
	};

	return (
		<Dropdown
			arrow={arrow}
			trigger={disabled ? [] : ['click']}
			placement={coverTrigger ? 'bottomRight' : 'bottomLeft'}
			align={
				coverTrigger ? { points: ['tr', 'tr'], offset: [0, 0] } : undefined
			}
			className={className}
			// overlayClassName={styles.overlay}
			overlay={
				<Menu onClick={handleClick}>
					{options.map((item) => {
						const isActive = value === item.key;
						return (
							<Menu.Item key={item.key}>
								<div
									className={cn(styles.menuItem, {
										[styles.menuItemActive]: isActive,
										[styles.dangerOption]: item.danger
									})}
								>
									{t(item.label)}
									{isActive ? (
										<Icon
											type="check"
											className={styles.menuItemIcon}
										/>
									) : null}
								</div>
							</Menu.Item>
						);
					})}
				</Menu>
			}
		>
			{children}
		</Dropdown>
	);
};

export default DropdownMenu;
